export default __webpack_public_path__ + "static/bodySectionBg-8d342af4e0a1e4453d3e038b737c136b.png";